// Farben der Miniaturwelt, abgeleitet aus der be2morrow-Markenpalette.
export const COLORS = {
  navy: 0x13192e,
  navy600: 0x2c3555,
  green: 0x47bb63,
  lime: 0xc1e130,
  paper: 0xf5f5f4,
  muted: 0x5e6067,
  slate: 0x9aa3b8,

  grass: 0x9fd18b,
  grassDark: 0x84bf70,
  field: 0xe3cf7a,
  fieldGreen: 0xb5d96a,
  soil: 0x8b6b4a,
  soilDark: 0x6b4f36,
  road: 0x6b6f7a,
  roadLine: 0xf5f5f4,
  water: 0x5aa9d6,

  wall: 0xf1efe9,
  wallWarm: 0xe6ded0,
  roof: 0x2c3555,
  roofLight: 0x9aa3b8,
  steel: 0x8a94a6,
  steelDark: 0x5f6878,
  rust: 0xc0703f,
  brick: 0xc96f53,
  orange: 0xf2a541,
  red: 0xe5624e,
  white: 0xffffff,
  glass: 0x7fb4d9,
  trunk: 0x7a5a3a,
  tree: 0x4f9a5b,
  treeLight: 0x6db36a,
  solar: 0x23406b,
  concrete: 0xc9c6bf,
  gravel: 0xb3aa9a,

  smokeDirty: 0x5b606b,
  smokeClean: 0xe9ecf1,
  cloudScope12: 0x4b5262,
  cloudScope3: 0x6f7c93
}
